/*
 * @Author: Json Chen
 * @Date: 2021-07-16 17:52:03
 * @LastEditTime: 2021-07-16 18:22:01
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/ShippingRate/Components/DropdownActions.tsx
 */
import React from 'react';

import { Dropdown } from 'antd';
import { Button } from '@/src/components/Antd';

// 样式参照linkLibrary 里的linkItem
import styles from '../style.module.less';

const DropdownActions = ({ index, children }) => {
  return (
    <Dropdown
      trigger={['click']}
      getPopupContainer={() =>
        document.getElementById(`shipping-rate-action-${index}`)
      }
      overlay={children}>
      <Button
        id={`shipping-rate-action-${index}`}
        className={styles.linkedItemActionsDropDownButton}>
        ···
      </Button>
    </Dropdown>
  );
};

export default DropdownActions;
